export default {
  en: {
    actions: {
      submit: "Submit",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
    },
  },

  de: {
    actions: {
      submit: "Senden",
      save: "Speichern",
      cancel: "Abbrechen",
      edit: "Bearbeiten",
      delete: "Löschen",
    },
  },
}
